<div class="d-flex align-items-center justify-content-end">
  <div class="preview" [class.preview--uploading]="isUploading">
    @if (preview) {
      <img
        [src]="getImageUrl(preview)"
        alt="File upload preview"
        />
    }
    @if (isUploading) {
      <span class="preview__status" aria-live="polite">Uploading…</span>
    }
  </div>
  <img
    class="controll-btn"
    src="/static/images/upload.png"
    (click)="!isUploading && fileInput.click()"
    [class.controll-btn--disabled]="isUploading"
    alt="upload"
    />@if (isDeletable) {
    <img
      class="controll-btn"
      src="/static/images/clear.png"
      alt="clear"
      (click)="!isUploading && clear()"
      [class.controll-btn--disabled]="isUploading"
      />
  }
  <input
    #fileInput
    hidden="hidden"
    type="file"
    [accept]="accept"
    [disabled]="isUploading"
  />
</div>
